"use strict";

exports.__esModule = true;
var _YesNo = require("./YesNo");
Object.keys(_YesNo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _YesNo[key]) return;
  exports[key] = _YesNo[key];
});